import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

class ItemReveal extends React.PureComponent {
  // constructor(props) {
  //   super(props);
  // }

  onClick = () => {
    this.props.onClick(this.props.id);
  };

  render() {
    const { item, renderTop, renderBody, style, className, open } = this.props;
    return (
      <div style={style} className={(!open ? 'collapsed ' : '') + className}>
        <div className='content'>
          <Icon
            type={!open ? 'caret-right' : 'caret-down'}
            onClick={this.onClick}
            className='expand-icon'
          />
          {renderTop(item)}
        </div>
        {open && renderBody(item)}
      </div>
    );
  }
}

ItemReveal.propTypes = {
  id: PropTypes.any.isRequired,
  item: PropTypes.object.isRequired,
  renderTop: PropTypes.func.isRequired,
  renderBody: PropTypes.func.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ItemReveal;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ItemRevealFast.js